module.exports = "pegasus_template/assets/square-pinterest.png";